import {
  faAddressBook,
  faAddressCard,
  faAirConditioner,
  faAlarmClock,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowUp,
  faArrowsLeftRight,
  faArrowsMaximize,
  faAt,
  faBackpack,
  faBadgePercent,
  faBagsShopping,
  faBallot,
  faBasketShopping,
  faBatteryThreeQuarters,
  faBell,
  faBoltLightning,
  faBook,
  faBookOpen,
  faBooks,
  faBox,
  faBoxCheck,
  faBoxOpenFull,
  faBoxesStacked,
  faBuilding,
  faCakeCandles,
  faCalculator,
  faCalculatorSimple,
  faCalendarAlt,
  faCalendarDays,
  faCamera,
  faCameraCctv,
  faCandyCane,
  faCar,
  faCarBuilding,
  faCartShopping,
  faChampagneGlasses,
  faChargingStation,
  faChartBar,
  faChartLine,
  faChartMixed,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faCity,
  faClipboardList,
  faClock,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudBolt,
  faCloudsSun,
  faCoffee,
  faCoins,
  faComment,
  faComments,
  faCompass,
  faCopy,
  faCreditCard,
  faDesktop,
  faDolly,
  faDownload,
  faDroplet,
  faEarthEurope,
  faEnvelope,
  faEnvelopeOpenText,
  faEuroSign,
  faExclamation,
  faEye,
  faEyeSlash,
  faFamily,
  faFaucet,
  faFile,
  faFileChartPie,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFileSearch,
  faFileSignature,
  faFileUser,
  faFileWord,
  faFingerprint,
  faFireAlt,
  faFloppyDisk,
  faFlowerDaffodil,
  faFolder,
  faGamepad,
  faGaugeSimpleLow,
  faGears,
  faGift,
  faGiftCard,
  faGlobe,
  faGrid,
  faHandHoldingBox,
  faHandHoldingDroplet,
  faHandHoldingSeedling,
  faHandsHoldingHeart,
  faHatChef,
  faHeart,
  faHeartPulse,
  faHelmetSafety,
  faHomeHeart,
  faHourglass,
  faHouse,
  faHouseChimney,
  faIdCard,
  faIdCardAlt,
  faImage,
  faIndustry,
  faInfo,
  faKey,
  faLaptop,
  faLeaf,
  faLightbulb,
  faLightbulbOn,
  faLightsHoliday,
  faLink,
  faList,
  faLocationCrosshairs,
  faLock,
  faMagnifyingGlass,
  faMailBulk,
  faMailbox,
  faMapLocation,
  faMapLocationDot,
  faMartiniGlassCitrus,
  faMicrophone,
  faMinus,
  faMobileScreenButton,
  faMoneyBill,
  faMountain,
  faMugHot,
  faNewspaper,
  faPen,
  faPenToSquare,
  faPeopleCarryBox,
  faPercent,
  faPersonDolly,
  faPhone,
  faPhoneVolume,
  faPiggyBank,
  faPlug,
  faPlus,
  faPowerOff,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faQuestion,
  faRectangleList,
  faRecycle,
  faRepeat,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faScaleBalanced,
  faScrewdriverWrench,
  faSeedling,
  faShapes,
  faShieldHalved,
  faShoePrints,
  faSignal,
  faSignsPost,
  faSirenOn,
  faSliders,
  faSlidersUp,
  faSnowflake,
  faSnowflakes,
  faSnowman,
  faSolarPanel,
  faStar,
  faStarChristmas,
  faStocking,
  faStreetView,
  faSuitcase,
  faSun,
  faSunCloud,
  faTag,
  faTags,
  faTemperatureSnow,
  faTemperatureSun,
  faThermometerQuarter,
  faThermometerThreeQuarters,
  faThumbsDown,
  faThumbsUp,
  faTowerBroadcast,
  faTrashCan,
  faTreeChristmas,
  faTriangleExclamation,
  faTrophy,
  faTruckContainer,
  faTruckFast,
  faTv,
  faUser,
  faUserGroup,
  faUserHelmetSafety,
  faUserShield,
  faUsers,
  faVacuum,
  faWandMagicSparkles,
  faWater,
  faWifi,
  faWifiSlash,
  faWindTurbine,
  faWreath,
  faXmark,
  faDrawSquare,
} from '@fortawesome/pro-solid-svg-icons';

const icons = [
  faAddressBook,
  faAddressCard,
  faAirConditioner,
  faAlarmClock,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowUp,
  faArrowsLeftRight,
  faArrowsMaximize,
  faAt,
  faBackpack,
  faBadgePercent,
  faBagsShopping,
  faBallot,
  faBasketShopping,
  faBatteryThreeQuarters,
  faBell,
  faBoltLightning,
  faBook,
  faBookOpen,
  faBooks,
  faBox,
  faBoxCheck,
  faBoxOpenFull,
  faBoxesStacked,
  faBuilding,
  faCakeCandles,
  faCalculator,
  faCalculatorSimple,
  faCalendarAlt,
  faCalendarDays,
  faCamera,
  faCameraCctv,
  faCandyCane,
  faCar,
  faCarBuilding,
  faCartShopping,
  faChampagneGlasses,
  faChargingStation,
  faChartBar,
  faChartLine,
  faChartMixed,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faCity,
  faClipboardList,
  faClock,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudBolt,
  faCloudsSun,
  faCoffee,
  faCoins,
  faComment,
  faComments,
  faCompass,
  faCopy,
  faCreditCard,
  faDesktop,
  faDolly,
  faDownload,
  faDroplet,
  faEarthEurope,
  faEnvelope,
  faEnvelopeOpenText,
  faEuroSign,
  faExclamation,
  faEye,
  faEyeSlash,
  faFamily,
  faFaucet,
  faFile,
  faFileChartPie,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFileSearch,
  faFileSignature,
  faFileUser,
  faFileWord,
  faFingerprint,
  faFireAlt,
  faFloppyDisk,
  faFlowerDaffodil,
  faFolder,
  faGamepad,
  faGaugeSimpleLow,
  faGears,
  faGift,
  faGiftCard,
  faGlobe,
  faGrid,
  faHandHoldingBox,
  faHandHoldingDroplet,
  faHandHoldingSeedling,
  faHandsHoldingHeart,
  faHatChef,
  faHeart,
  faHeartPulse,
  faHelmetSafety,
  faHomeHeart,
  faHourglass,
  faHouse,
  faHouseChimney,
  faIdCard,
  faIdCardAlt,
  faImage,
  faIndustry,
  faInfo,
  faKey,
  faLaptop,
  faLeaf,
  faLightbulb,
  faLightbulbOn,
  faLightsHoliday,
  faLink,
  faList,
  faLocationCrosshairs,
  faLock,
  faMagnifyingGlass,
  faMailBulk,
  faMailbox,
  faMapLocation,
  faMapLocationDot,
  faMartiniGlassCitrus,
  faMicrophone,
  faMinus,
  faMobileScreenButton,
  faMoneyBill,
  faMountain,
  faMugHot,
  faNewspaper,
  faPen,
  faPenToSquare,
  faPeopleCarryBox,
  faPercent,
  faPersonDolly,
  faPhone,
  faPhoneVolume,
  faPiggyBank,
  faPlug,
  faPlus,
  faPowerOff,
  faPrint,
  faPuzzlePiece,
  faQrcode,
  faQuestion,
  faRectangleList,
  faRecycle,
  faRepeat,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faScaleBalanced,
  faScrewdriverWrench,
  faSeedling,
  faShapes,
  faShieldHalved,
  faShoePrints,
  faSignal,
  faSignsPost,
  faSirenOn,
  faSliders,
  faSlidersUp,
  faSnowflake,
  faSnowflakes,
  faSnowman,
  faSolarPanel,
  faStar,
  faStarChristmas,
  faStocking,
  faStreetView,
  faSuitcase,
  faSun,
  faSunCloud,
  faTag,
  faTags,
  faTemperatureSnow,
  faTemperatureSun,
  faThermometerQuarter,
  faThermometerThreeQuarters,
  faThumbsDown,
  faThumbsUp,
  faTowerBroadcast,
  faTrashCan,
  faTreeChristmas,
  faTriangleExclamation,
  faTrophy,
  faTruckContainer,
  faTruckFast,
  faTv,
  faUser,
  faUserGroup,
  faUserHelmetSafety,
  faUserShield,
  faUsers,
  faVacuum,
  faWandMagicSparkles,
  faWater,
  faWifi,
  faWifiSlash,
  faWindTurbine,
  faWreath,
  faXmark,
  faDrawSquare,
];

export default icons;
